const initialState = {
  list: {
    isLoading: false,
    error: '',
    data: [],
  },
};

export default initialState;
